import { render, staticRenderFns } from "./ChatGPTBubble.vue?vue&type=template&id=3fc498ea&"
import script from "./ChatGPTBubble.vue?vue&type=script&lang=js&"
export * from "./ChatGPTBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports